<template>
  <b-modal
    id="timesheet-notes"
    ref="timesheet-notes"
    modal-class="timesheet-notes-modal"
    size="sm-size"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        Timesheet Notes
      </h2>
    </div>
    <div class="content-wrapper">
      <textarea
        v-model="message"
        name="notes"
        class="manual-entry-notes"
        minlength="5"
        maxlength="5000"
        placeholder="Add your message here…"
      />
    </div>
    <div class="modal-footer">
      <button
        type="reset"
        class="atto-btn cancel"
        @click="close"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="atto-btn submit"
        :disabled="disabledSaveButton"
        @click="addNoteChanges"
      >
        Send Message
      </button>
    </div>
  </b-modal>
</template>

<script>
    export default {
        name: "TimesheetNotesComponent",
        data(){
            return {
                disabledSaveButton: false
            }
        },
        mounted(){
            document.body.appendChild(this.$el);
            this.$refs['timesheet-notes'].show();
        },
        methods: {
            addNoteChanges(){},
            close(){
                this.$root.$emit('hideTimesheetNotes');
            }
        }
    }

</script>

<style lang="scss">
    .timesheet-notes-modal {
        .modal-dialog {
            .modal-footer {
                flex-direction: row;
            }
            .content-wrapper {
                textarea {
                    padding: 8px 12px;
                    width: 100%;
                    min-height: 160px;
                    border: 2px solid $atto-light-grey;
                    font-family: $roboto-font;
                    font-weight: $roboto-medium;
                    font-size: 0.875rem;
                    line-height: 1.25rem;
                    overflow-y: hidden;
                    @include base-transition(ease all 0.15s);
                    @include style-placeholder($atto-not-active);

                    &:focus{
                        border-color: $atto-dark-grey;
                        outline: 0;
                        box-shadow: none;
                    }
                }
            }
        }
    }
</style>